import { createAction } from '@reduxjs/toolkit';

export const SOCKET_SUBSCRIBE_TYPE = 'saga/socketSubscribe';
export const socketSubscribeAction = createAction(SOCKET_SUBSCRIBE_TYPE);
